import { useEffect, useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { BASE_URL } from '../actions';

export default function useReportSetup(caseId, open, includeDocuments) {
  const [attempt, setAttempt] = useState(0);
  const key = `${caseId}:${open}:${includeDocuments}:${attempt}`;
  const [state, setState] = useState({ key, loading: true, documents: [] });
  useEffect(() => {
    if (!open) return;
    const controller = new AbortController();
    const config = { signal: controller.signal, timeout: 30000, headers: { Authorization: `Bearer ${Cookies.get('token')}` } };
    let metadata;
    setState({ key, loading: true, documents: [] });
    (async () => {
      try {
        const response = await axios.post(`${BASE_URL}/case/report-options`, { caseId: Number(caseId) }, config);
        const candidate = response.data?.options;
        if (!response.data?.ok || Number(candidate?.case_id) !== Number(caseId) || !candidate?.client_id ||
          !Array.isArray(candidate.available_scopes) || !candidate.available_scopes.includes('all')) throw new Error('Invalid options');
        metadata = candidate;
        if (controller.signal.aborted) return;
        setState({ key, loading: false, metadata, documents: [], documentsLoading: includeDocuments });
        if (!includeDocuments) return;
        // Use the original file/folder listing. Dates and report generation do
        // not decide which documents are offered in the export dialog.
        const documents = await axios.get(`${BASE_URL}/storage/get-client-and-case-documents`, {
          ...config, params: { client_id: metadata.client_id, case_id: Number(caseId) },
        });
        if (controller.signal.aborted) return;
        const data = documents.data;
        if (!data?.ok && data?.message !== 'Client root folder not found') throw new Error('Documents unavailable');
        const choices = (data.contents || []).filter(item => item.type === 'file' || (item.type === 'folder' && item.number_of_children > 0))
          .map(item => ({ id: item.id, name: item.name, source_table: item.type === 'folder' ? 'folders' : 'files' }));
        setState({ key, loading: false, metadata, documents: choices, documentsLoading: false });
      } catch {
        if (controller.signal.aborted) return;
        setState({ key, loading: false, metadata, documents: [], documentsLoading: false,
          ...(metadata ? { documentsError: 'Unable to load documents.' } : { error: 'Unable to load report options.' }) });
      }
    })();
    return () => controller.abort();
  }, [caseId, open, includeDocuments, attempt, key]);
  return { ...(state.key === key ? state : { loading: open, documents: [] }), retry: () => setAttempt(value => value + 1) };
}
